import {
  takeLatest, put, call,
} from 'redux-saga/effects';
import { message } from 'antd';
import { fetchDashboard } from '@api/dashboards';
import { autoRequest } from '@api/createRequestStore';

import { CLOSE_ALL_TABS } from '@store/common/types';
import * as autoRequestTypes from '@api/createRequestStore/types';
import * as actions from './actions';
import * as types from './types';
// import { dashboardResponseSelector } from './selectors';
// import { filterShareddData } from '../base/utils';

function* afterRequest() {
  // const dashboard = yield select(dashboardResponseSelector);
  // if (!dashboard) {
  //   return;
  // }

  // const { config } = dashboard;
  // try {
  //   const { base } = config;
  //   const filteredState = filterShareddData(base);
  //   yield put(baseActions.updateBase(filteredState));

  // } catch (error) {
  //   throw error;
  // }
}

function* initRequest() {
  yield put(actions.initRequest());
}

function* fetching(action) {
  try {
    yield put({ type: `${types.SCOPE}${autoRequestTypes.FETCHING}` });
    yield autoRequest(fetchDashboard, types.SCOPE, action.id, afterRequest);
  } catch (error) {
    yield call(message.error, error.message || 'Unknown error.');
    throw error;
  }
}

function* watchInitRequest() {
  yield takeLatest([types.INIT, CLOSE_ALL_TABS], initRequest);
}

function* watchFetching() {
  yield takeLatest([types.GET_DASHBOARD], fetching);
}

export default [watchInitRequest, watchFetching];
